import { SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { ModalWithButtons } from "../../../../common-components/modals/modal";
import { BlackButton, GreyButton } from "../../../../common-components/button";
import { CustomTextInput } from "../../../../common-components/inputs";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
}

export default function DeleteLicenseConfirmModal(props: Props) {
	const { t: translation } = useTranslation();

	const [confirmText, setConfirmText] = useState<string>("");

	const modal: React.ReactNode = (
		<ModalWithButtons
			headerText={""}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<GreyButton
					key="delete-sample-cancel-button"
					id="delete-sample-cancel-button"
					children={translation("Cancel")}
					onClick={() => {
						props.setOpen(false);
					}}
				></GreyButton>,
				<BlackButton
					key="delete-sample-proceed-button"
					id="delete-sample-proceed-button"
					children={translation("Delete")}
					disabled={confirmText !== translation("Confirm")}
					onClick={() => {
						setTimeout(() => props.proceedAction(), 1);
						props.setOpen(false);
					}}
				></BlackButton>,
			]}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "5px",
					alignItems: "center",
					textAlign: "center",
					marginTop: "-10px",
				}}
			>
				<div className="modal-body-icon delete-sample-icon"></div>

				<div className="typography-body-02 typography-bold">
					{`${translation("DeleteLicense")}?`}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("DeleteLicenseMessage")}
				</div>
				<div
					className="typography-caption"
					style={{ color: NeutralColor.NEUTRAL_GREY_500 }}
				>
					{translation("CannotUndoAction")}
				</div>
				<CustomTextInput
					id={`delete-modal-confirm-textbox`}
					key={`delete-modal-confirm-textbox`}
					value={confirmText}
					setValue={setConfirmText}
					placeholder={translation("Confirm")}
					type="text"
					required={true}
				></CustomTextInput>
			</div>
		</ModalWithButtons>
	);

	return modal;
}
